import { ProblemCarEnum } from '@services/report'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

type Props = {
  isShowAll?: boolean
} & SelectProps

export default function ProblemCarItemSelect({
  isShowAll = false,
  ...props
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex">
      <Select {...props}>
        {isShowAll && (
          <Select.Option key="all" value={0}>
            {t('common:all')}
          </Select.Option>
        )}
        {ProblemCarEnum.map(x => (
          <Select.Option key={x.value} value={x.value}>
            {x.name}
          </Select.Option>
        ))}
      </Select>
    </div>
  )
}
